import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ICRMConnectionInfoHolder, IResultOfType } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class Dynamics365ConnectionService {
  private getBaseRoute(instanceId: string): string {
    return `/api/configurations/${instanceId}/dynamics-365`;
  }
  constructor(private http: HttpClient) {}

  getConnection(instanceId: string): Observable<ICRMConnectionInfoHolder> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.get<ICRMConnectionInfoHolder>(baseRoute);
  }

  testConnection(instanceId: string, connection: ICRMConnectionInfoHolder): Observable<IResultOfType<string>> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.post<IResultOfType<string>>(`${baseRoute}/test`, connection);
  }

  upsertConnection(instanceId: string, connection: ICRMConnectionInfoHolder): Observable<any> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.put<any>(baseRoute, connection);
  }
}
